import { Row, Col, Card, Table, Divider, Statistic, DatePicker } from "antd";
import {
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import useTrainingReports from "./logic/useTrainingReports";
import "./TrainingReports.scss";
const { RangePicker } = DatePicker;
const TrainingReports = () => {
  const {
    upcomingTrainings,
    planColumns,
    transformedCompletionByMonth,
    trainingCompletionData,
    upcomingTrainingsColumns,
    loadingUpcoming,
    averageDuration,
    setFromDate,
    refetchCompletion,
    setToDate,
    setPlanFromDate,
    setPlanToDate,
    filteredPlans,
  } = useTrainingReports();

  return (
    <div className="training-dashboard">
      <Divider />

      {/* Dashboard Cards */}
      <Row gutter={16} className="dashboard-cards">
        <Col span={4}>
          <Card>
            <Statistic
              title="Total Trainings"
              value={averageDuration?.totalTrainings || 0}
            />
          </Card>
        </Col>
        <Col span={4}>
          <Card>
            <Statistic
              title="Total Sessions"
              value={averageDuration?.totalSessions || 0}
            />
          </Card>
        </Col>
        <Col span={4}>
          <Card>
            <Statistic
              title="Average Duration (hours)"
              value={parseFloat(averageDuration?.averageDuration || "0")}
              precision={2}
            />
          </Card>
        </Col>
      </Row>

      {/* Completion by Month & Training Plans */}
      <Row gutter={[16, 16]}>
        <Col span={16}>
          <Card title="Completion by Month" className="training-completion">
            <RangePicker
              className="range-picker"
              onChange={(dates) => {
                if (dates) {
                  setFromDate(dates[0].toISOString());
                  setToDate(dates[1].toISOString());
                  refetchCompletion();
                }
              }}
              format="YYYY-MM-DD"
            />
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={transformedCompletionByMonth}>
                <XAxis dataKey="month" />
                <YAxis allowDecimals={false} />
                <Tooltip />
                <Legend />
                <Bar dataKey="completed" fill="#82ca9d" name="Completed" />
                <Bar dataKey="pending" fill="#8884d8" name="Pending" />
              </BarChart>
            </ResponsiveContainer>
          </Card>
        </Col>

        <Col span={8}>
          <Card
            title="Trainings Completion Overview (Current Month)"
            className="training-completion"
          >
            {trainingCompletionData &&
            trainingCompletionData.length > 0 &&
            trainingCompletionData.some((item) => item.value > 0) ? (
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={trainingCompletionData}
                    dataKey="value"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    outerRadius={80}
                    label
                  >
                    {trainingCompletionData.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={index === 0 ? "#82ca9d" : "#ff4538"}
                      />
                    ))}
                  </Pie>
                  <Tooltip
                    formatter={(value, name) => [`${value} Trainings`, name]}
                  />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            ) : (
              <div
                style={{
                  textAlign: "center",
                  color: "#bbb",
                  padding: 40,
                  minHeight: 200,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                No trainings scheduled for this month.
              </div>
            )}
          </Card>
        </Col>
      </Row>

      {/* Training Plans Overview */}
      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col span={24}>
          <Card title="Training Plans Overview" className="table-card">
            <RangePicker
              className="range-picker"
              onChange={(dates) => {
                if (dates) {
                  setPlanFromDate(dates[0].toISOString());
                  setPlanToDate(dates[1].toISOString());
                } else {
                  setPlanFromDate(null);
                  setPlanToDate(null);
                }
              }}
              format="YYYY-MM-DD"
            />
            <Table
              columns={planColumns}
              dataSource={filteredPlans}
              rowKey="trainingId"
              pagination={false}
              locale={{ emptyText: "No training plans found." }}
            />
          </Card>
        </Col>
      </Row>

      {/* Upcoming Trainings */}
      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col span={24}>
          <Card title="Upcoming Trainings">
            <Table
              dataSource={upcomingTrainings}
              columns={upcomingTrainingsColumns}
              rowKey="trainingId"
              pagination={false}
              loading={loadingUpcoming}
              locale={{ emptyText: "No upcoming trainings found." }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default TrainingReports;
